import { SettingsPaths } from "Pages/settings/paths";

export const DATA_MANAGEMENT_SPOTLIGHT_TITLES = {
    [SettingsPaths.eventManagement]: "Manage Events",
    [SettingsPaths.objectTypes]: "Manage Custom Objects",
} as const;

export const DATA_MANAGEMENT_PAGE_DESCRIPTIONS = {
    [SettingsPaths.eventManagement]: "Event tracking and management configuration.",
    [SettingsPaths.objectTypes]: "Custom data object creation and management.",
} as const;
